import React from 'react';
import SeoMetadata from '../components/Seo/SeoMetadata';
import TituloMuroLambrinConcavo from '../components/sections/MuroLambrinConcavo/TituloMuroLambrinConcavo';
import IntroMuroLambrinConcavo from '../components/sections/MuroLambrinConcavo/IntroMuroLambrinConcavo';
import CaracteristicasMuroLambrinConcavo from '../components/sections/MuroLambrinConcavo/CaracteristicasMuroLambrinConcavo';
import FormularioContactoConcavo from '../components/sections/MuroLambrinConcavo/FormularioContactoConcavo';
import Header from '../components/layouts/Header'; 
import Footer from '../components/layouts/Footer';

const MuroLambrinConcavo = () => {
  return (
    <div>
      <SeoMetadata
        title="Lambrín Cóncavo para Muros | Decototal"
        description="Renueva tus espacios con lambrín cóncavo para muros. Conoce sus acabados, aplicaciones y solicita información para tu proyecto."
        keywords="lambrín cóncavo, lambrín WPC, revestimiento para muros, panel decorativo"
        path="/muro-lambrin-concavo"
        image="/assets/img/productos/muro-lambrin-concavo/muro-lambrin-concavo-titulo.jpg"
      />
      <Header />

        <TituloMuroLambrinConcavo /> 
        <IntroMuroLambrinConcavo />
        <CaracteristicasMuroLambrinConcavo />  
        <FormularioContactoConcavo />  
      <Footer />
    </div>
  );
};

export default MuroLambrinConcavo;